/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quantity: NonNullable<unknown> }} Tea_Grade_Stock_QuantityInputs */

const vi_tea_grade_stock_quantity = /** @type {(inputs: Tea_Grade_Stock_QuantityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tồn: ${i?.quantity} kg`)
};

/**

* @param {Tea_Grade_Stock_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_stock_quantity = /** @type {((inputs: Tea_Grade_Stock_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Stock_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_stock_quantity(inputs)
});